var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "user-block" }, [
    !_vm.queryChangeCode
      ? _c("div", {}, [
          _c("div", { staticClass: "user-block__title" }, [
            _vm._v("Что-то пошло не так..."),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-block__text" }, [
            _vm._v("Вы можете обратиться за помощью к аутсорсеру."),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.queryChangeCode && _vm.statusBlock === "outdated"
      ? _c("div", {}, [
          _c("div", { staticClass: "user-block__title" }, [
            _vm._v("Срок действия ссылки истек"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-block__text" }, [
            _vm._v("Вы можете обратиться за помощью к аутсорсеру."),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.queryChangeCode && _vm.statusBlock === "blocked"
      ? _c("div", {}, [
          _c("img", {
            staticClass: "user-block__icon-check",
            attrs: { src: require("@icons/chat/check-circle-filled.svg") },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "user-block__title" }, [
            _vm._v("Ваш аккаунт успешно заблокирован"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user-block__text" }, [
            _vm._v(
              "После восстановления доступа рекомендуем изменить пароль для входа."
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.queryChangeCode && _vm.statusBlock === "ok"
      ? _c(
          "div",
          {},
          [
            _c("img", {
              staticClass: "user-block__img",
              attrs: { src: require("@icons/user-block.svg"), alt: "logo.svg" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "user-block__title" }, [
              _vm._v("Ваша почта отключена от сервиса 1С:БухОбслуживание"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-block__text" }, [
              _vm._v(
                "\n      Если это действие совершено не Вами или не по Вашей просьбе, вы можете заблокировать свой аккаунт — доступ к\n      сервису будет заблокирован, все сеансы будут завершены.\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-block__text" }, [
              _vm._v(
                "\n      После блокировки обратитесь к своему аутсорсеру для изменения данных и восстановления доступа к сервису.\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "ButtonWithLoader",
              {
                staticClass: "user-block__btn",
                attrs: { "is-blocked": _vm.isBlockLoading },
                on: {
                  click: function ($event) {
                    return _vm.doBlock()
                  },
                },
              },
              [_vm._v("\n      Заблокировать аккаунт\n    ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }